import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SectionTooltipService } from 'src/app/services/section-tooltip/section-tooltip.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-section-preview-pill',
  templateUrl: './section-preview-pill.component.html',
  styleUrls: ['./section-preview-pill.component.scss'],
})
export class SectionPreviewPillComponent implements OnInit, OnDestroy {
  @Input() sectionId: number;
  @Input() countrySlug: string;
  @Input() countryName: string;

  pillLabel: string;

  @ViewChild('pillLink') pillLink: ElementRef;

  private hoverSubject = new Subject<boolean>();
  private destroy$ = new Subject<void>();

  constructor(
    public tooltipService: SectionTooltipService,
    private documentService: DocumentService,
  ) {
    this.hoverSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300),
    ).subscribe(show => {
      if (show) {
        this.showTooltip();
      } else if (!this.tooltipService.tooltipHovered) {
        this.tooltipService.hide();
      }
    });
  }

  ngOnInit() {
    this.pillLabel = this.countryName ? `${this.countryName} Country Profile` : 'View in Country Profile';
    if (this.sectionId) {
      this.documentService.getDocumentSectionTemplate(this.sectionId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(section => {
          if (section?.name) {
            this.pillLabel = this.countryName
              ? `${this.countryName} - ${section.name}`
              : section.name;
          }
        });
    }
  }

  get profileUrl(): string {
    return `/country/${this.countrySlug}/profile?id=${this.sectionId}`;
  }

  onPillEnter() {
    this.tooltipService.cancelHide();
    this.hoverSubject.next(true);
  }

  onPillLeave() {
    this.hoverSubject.next(false);
    this.tooltipService.scheduleHide();
  }

  private showTooltip() {
    if (!this.pillLink) return;

    const rect = this.pillLink.nativeElement.getBoundingClientRect();
    const tooltipWidth = 600;
    const tooltipMaxHeight = 400;
    const edgePadding = 20;

    let x = rect.left;
    let y = rect.bottom + 5;

    if (x + tooltipWidth + edgePadding > window.innerWidth) {
      x = Math.max(edgePadding, window.innerWidth - tooltipWidth - edgePadding);
    }

    if (y + tooltipMaxHeight + edgePadding > window.innerHeight) {
      y = Math.max(edgePadding, rect.top - tooltipMaxHeight - 5);
    }

    this.tooltipService.show(this.sectionId, x, y);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
